import { render } from "./SubscriptionOverview.vue?vue&type=template&id=b0004610&scoped=true"
import script from "./SubscriptionOverview.vue?vue&type=script&lang=js"
export * from "./SubscriptionOverview.vue?vue&type=script&lang=js"

import "./SubscriptionOverview.vue?vue&type=style&index=0&id=b0004610&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0004610"]])

export default __exports__